import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { SentryErrorHandler } from './sentry-error-handler.service';
import { SentryDataCapture } from './sentry-data-capture.service';
import { environment } from 'src/environments/environment';
import * as Sentry from '@sentry/browser';
import { HttpClient } from '@angular/common/http';

/**
 * Factory function initializes Sentry configuration
 * BEFORE the app is initialized.
 */
const initSentry = async (http: HttpClient) => {
  const sentryConfig = await http
    .get('assets/config/sentry.json')
    .toPromise()
    .catch(() => null);

  if (!sentryConfig) {
    // eslint-disable-next-line no-console
    console.error('Sentry initialization failed, sentry.json not found');
    return;
  }

  if (!environment.sentry.enabled) {
    // eslint-disable-next-line no-console
    console.error('Sentry config loaded, but Sentry is not enabled for this build.');
    return;
  }

  Sentry.init({
    dsn: 'https://0440881a2993407fab5d125a213727d3@o395550.ingest.sentry.io/5248412',
    ...sentryConfig,
  });
};

@NgModule({
  providers: [
    SentryDataCapture,
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    {
      provide: APP_INITIALIZER,
      useFactory: (httpClient: HttpClient) => () => initSentry(httpClient),
      deps: [HttpClient],
      multi: true,
    },
  ],
})
export class SentryModule {}
